 import './App.css';
import Section1 from './Components/Section1';
import Section2 from './Components/Section2';
import Section3 from './Components/Section3';
import Section4 from './Components/Section4';
import Section5 from './Components/Section5';
import Section6 from './Components/Section6';
import Footer from './Components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavBar from './Components/NavBar';
import React, { useState,useEffect } from 'react' 

import ClipLoader from "react-spinners/ClipLoader";
function App() {
let [loading, setLoading] = useState(false);
useEffect(()=>{
  setLoading(true);
  setTimeout(()=>{
    setLoading(false);
  },5000)
},[])

  return (
    <>
    {
    loading?
    <ClipLoader color={"#D0021B"} className="position-absolute top-50 start-50 " 
    loading={loading} size={50} />
      :
      <div>
      <NavBar/> 
      <Section1/>
      <Section2/> 
      <Section3/>
      <Section4/>
      <Section5/>
      <Section6/>
      <Footer/>
      </div>
    }
      
    </>
  );
}

export default App;
